// extracted by mini-css-extract-plugin
export default {"p2":"P2_p2__XsuCt","bold":"P2_bold__GFSwI"};